import { render, staticRenderFns } from "./CRMenu.vue?vue&type=template&id=3e25ab6e&scoped=true"
import script from "./CRMenu.vue?vue&type=script&lang=js"
export * from "./CRMenu.vue?vue&type=script&lang=js"
import style0 from "./CRMenu.vue?vue&type=style&index=0&id=3e25ab6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e25ab6e",
  null
  
)

export default component.exports